import Vue from 'vue';
import Service from '@/features/reports/service';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_REPORTS = 'UPDATE_REPORTS';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const UPDATE_EMPLOYEES = 'UPDATE_EMPLOYEES';
export const UPDATE_PREREPORTS_FORMAT = 'UPDATE_PREREPORTS_FORMAT';
export const FORMAT_REPORT_BEFORE_UPDATE = 'FORMAT_REPORT_BEFORE_UPDATE';
export const initModuleAction = 'initModuleAction';
export const updateReportsAction = 'updateReportsAction';

export default {
  namespaced: true,
  state: {
    searchingReports: false,
    report: {
      pr_comercial: '',
      pr_juridico: '',
      pr_financiero: '',
      pr_final: '',
      pr_riesgos: '',
      id: '',
    },
    prereport: {
      pr_comercial: '',
      pr_juridico: '',
      pr_financiero: '',
      pr_final: '',
      id: '',
    },
    error: '',
    employees: [],
    operation: {},
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'report', {
        pr_comercial: '',
        pr_juridico: '',
        pr_financiero: '',
        pr_final: '',
        pr_riesgos: '',
        id: '',
      });
      Vue.set(state, 'error', '');
      Vue.set(state, 'employees', []);
    },
    [UPDATE_ERROR](state, msg) {
      Vue.set(state, 'error', msg);
    },
    [UPDATE_REPORTS](state, payload) {
      const strIdentifier = '\n -- Valoraciones -- \n';
      Vue.set(state, 'report', payload);
      if (state.prereport.pr_comercial && state.prereport.pr_comercial.length > 0) {
        if (state.report.pr_comercial && state.report.pr_comercial.length) {
          state.report.pr_comercial = state.prereport.pr_comercial + strIdentifier + state.report.pr_comercial;
        } else {
          state.report.pr_comercial = state.prereport.pr_comercial + strIdentifier;
        }
      }
      if (state.prereport.pr_financiero && state.prereport.pr_financiero.length > 0) {
        if (state.report.pr_financiero && state.report.pr_financiero.length) {
          state.report.pr_financiero = state.prereport.pr_financiero + strIdentifier + state.report.pr_financiero;
        } else {
          state.report.pr_financiero = state.prereport.pr_financiero + strIdentifier;
        }
      }
      if (state.prereport.pr_juridico && state.prereport.pr_juridico.length > 0) {
        if (state.report.pr_juridico && state.report.pr_juridico.length) {
          state.report.pr_juridico = state.prereport.pr_juridico + strIdentifier + state.report.pr_juridico;
        } else {
          state.report.pr_juridico = state.prereport.pr_juridico + strIdentifier;
        }
      }
    },
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [UPDATE_EMPLOYEES](state, payload) {
      payload.forEach((e) => {
        state.employees.push(e.attributes.title);
      });
    },
    [FORMAT_REPORT_BEFORE_UPDATE](state) {
      if (state.report.pr_comercial) {
        if (state.report.pr_comercial.split('-- Valoraciones --', state.report.pr_comercial.length)[1] !== undefined) {
          state.report.pr_comercial = state.report.pr_comercial.split('-- Valoraciones --', state.report.pr_comercial.length)[1];
        }
      }
      if (state.report.pr_financiero) {
        if (state.report.pr_financiero.split('-- Valoraciones --', state.report.pr_financiero.length)[1] !== undefined) {
          state.report.pr_financiero = state.report.pr_financiero.split('-- Valoraciones --', state.report.pr_financiero.length)[1];
        }
      }
      if (state.report.pr_juridico) {
        if (state.report.pr_juridico.split('-- Valoraciones --', state.report.pr_juridico.length)[1] !== undefined) {
          state.report.pr_juridico = state.report.pr_juridico.split('-- Valoraciones --', state.report.pr_juridico.length)[1];
        }
      }
    },
    [UPDATE_PREREPORTS_FORMAT](state, payload) {
      const strIdentifier = '-- Pre-valoraciones -- \n';
      if (payload.pr_comercial && payload.pr_comercial.length) {
        payload.pr_comercial = strIdentifier + payload.pr_comercial;
      }
      if (payload.pr_financiero && payload.pr_financiero.length) {
        payload.pr_financiero = strIdentifier + payload.pr_financiero;
      }
      if (payload.pr_juridico && payload.pr_juridico.length) {
        payload.pr_juridico = strIdentifier + payload.pr_juridico;
      }
      Vue.set(state, 'prereport', payload);
    },
  },
  actions: {
    [initModuleAction]({ commit, rootGetters }, payload) {
      const { operation } = payload;
      commit(CLEAR_MODULE);
      commit(UPDATE_OPERATION, operation);
      commit(UPDATE_EMPLOYEES, []);
      return Service.getEmployees()
          .then((res) => {
            commit(UPDATE_EMPLOYEES, res.data.data);
            Service.getReportByOperationId(operation.id)
              .then((reports) => {
                Service.getPreReportByOperationId(operation.id)
                  .then((data) => {
                    commit(UPDATE_PREREPORTS_FORMAT, data);
                    return commit(UPDATE_REPORTS, reports);
                  });
              });
          });
    },
    [updateReportsAction]({ commit, state, dispatch }, payload) {
      commit(FORMAT_REPORT_BEFORE_UPDATE, payload);
      let preReportData = {};
      let promise = null;
      let msg = '';
      let today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      today = `${dd}/${mm}/${yyyy}`;
      switch (payload.$event.title) {
        case 'Analista Comercial':
          if (state.report.pr_comercial && state.report.pr_comercial.length) {
            msg = `${state.report.pr_comercial}\n`;
          }
          break;
        case 'Analista Juridico':
          if (state.report.pr_juridico && state.report.pr_juridico.length) {
            msg = `${state.report.pr_juridico}\n`;
          }
          break;
        case 'Responsable Financiero':
          if (state.report.pr_financiero && state.report.pr_financiero.length) {
            msg = `${state.report.pr_financiero}\n`;
          }
          break;
        case 'Sancion Riesgos':
          if (state.report.pr_riesgos && state.report.pr_riesgos.length) {
            msg = `${state.report.pr_riesgos}\n`;
          }
          break;
        default:
          msg = '';
      }

      if (payload.$event.option === 'Aprobado') {
        msg += `[${today} - ${payload.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Aprobado') {
        msg += `[${today} - ${payload.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.option === 'Denegado') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Denegado') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.option === 'Condicionar' || payload.$event.option === 'Condicionado') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.option}\n${payload.$event.model.comment}`;
      } else if (payload.$event.model.option === 'Condicionar' || payload.$event.model.option === 'Condicionado') {
        msg += `[${today} - ${payload.$event.model.user}] ${payload.$event.model.option}\n${payload.$event.model.comment}`;
      }
      if (payload.$event.title === 'Analista Comercial') {
        preReportData = {
          pr_comercial: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Analista Juridico') {
        preReportData = {
          pr_juridico: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Responsable Financiero') {
        preReportData = {
          pr_financiero: msg,
          id: payload.id,
        };
      } else if (payload.$event.title === 'Sancion Riesgos') {
        preReportData = {
          pr_riesgos: msg,
          id: payload.id,
        };
      }
      promise = dispatch('report_model/upsertEntityAction', preReportData, { root: true });
     // promise = Service.updateReport(preReportData);
      return promise
        .then(newData => commit(UPDATE_REPORTS, newData));
    },
  },
  getters: {
    employees: state => state.employees,
    report: state => state.report,
  },
};



// WEBPACK FOOTER //
// ./src/features/reports/store.js